import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../components/Button";
import "../styles/global.css";
import ForgotPass from "../assets/ForgotPass.png";
import { useNotification } from "../context/NotificationContext";
import {
  handleApiResponse,
  handleApiError,
} from "../utils/notificationHelpers";

// auth service import
import authApi from "../apiServices/auth"; // Import default export

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false); // optional loading state
  const { notify } = useNotification();
  const navigate = useNavigate();

  const handleForgotPassword = async (e) => {
    e.preventDefault();

    if (!email) {
      notify.warning("Please enter your email.");
      return;
    }

    try {
      setLoading(true);

      const result = await authApi.forgotPassword(email);

      if (handleApiResponse(result, notify, "OTP sent successfully.")) {
        // Save email to localStorage for OTP verification page
        localStorage.setItem("resetEmail", email);
        navigate("/verify-otp");
      }
    } catch (error) {
      handleApiError(error, notify);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center gap-10 h-screen bg-[#FEF3E7] padding-x">
      {/* Left Side - Image */}
      <div className="hidden md:flex items-center justify-center md:w-2/5 lg:w-1/2">
        <img
          src={ForgotPass}
          alt="Forgot Password"
          className="max-w-xs md:max-w-md object-contain"
        />
      </div>

      {/* Right Side - Forgot Password Form */}
      <div className="w-full md:w-3/5 lg:w-3/5 xl:w-2/5 flex flex-col items-center justify-center xl:p-2 bg-white shadow-lg">
        <img
          src="/Logo.png"
          alt="Logo"
          className="w-16 md:w-20 lg:w-24 mx-auto mb-12 md:mb-16"
        />
        <h2 className="text-4xl md:text-3xl xl:text-4xl font-bold mb-8">
          Forgot Password
        </h2>
        <p className="mb-10 text-center w-[70%] text-lg">
          Please enter your registered email address to receive a verification
          code.
        </p>

        <form className="w-full px-6" onSubmit={handleForgotPassword}>
          <div className="mb-10">
            <input
              type="email"
              placeholder="Enter your email"
              className="w-full px-3 py-2.5 border border-black rounded-md focus:ring-2 focus:ring-orange-500 placeholder:text-gray-500"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <Button
            text={loading ? "Sending..." : "Send"}
            type="submit"
            disabled={loading}
            className="mt-2 w-full"
          />
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
